package games.polyclub.website.frontend.store.pages.aof7

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.br
import games.polyclub.frontend.lib.react.simplified.tags.img
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.frontend.lib.react.simplified.tags.strong
import react.Props

val AOF7HowToPlay = SFC<Props> { _ ->
    p {
        +"Para jogar você precisa instalar o modpack com o CurseForge ou PrismLauncher, e ter posse de um Passe de Acesso."
    }
    p {
        +"Veja a aba \"Como Instalar\" e a aba \"Passe de Acesso\" para obter informações."
    }
    p {
        +"Com o modpack aberto, clique em "
        strong {
            +"Multijogador"
        }
        +" e adicione um novo servidor com o nome "
        strong {
            +"GameMods: All Of Fabric 7"
        }
        +" e endereço "
        strong {
            +"aof.gamemods.com.br"
        }
        +". Em seguida entre no servidor para jogar."
        br()
        img("w-25") {
            src = "/img/aof7/screenshot/como-conectar.jpg"
        }
    }
}
